const TextLength = ({
  textLength,
  maxTextLength
}: {
  textLength: number;
  maxTextLength?: number;
}) => {
  return <span className="text-caption-lg-semibold text-assistive " data-sentry-component="TextLength" data-sentry-source-file="TextLength.tsx">
      {textLength}/{maxTextLength}
    </span>;
};
export { TextLength };